module.exports = __webpack_public_path__ + "static/media/Sample-Manuscript.b824c951.pdf";